
import axios from 'axios';


export async function getData(){
  try {
    const responce = await axios.post('https://izba.kras-abs.ru/api/visitka/client/byCompanyId', {company_id: 1})
    return responce.data.clients.reverse()
  } catch (e) {
    // API недоступен (в т.ч. при пререндере) — отдаём пустой список,
    // чтобы не ронять страницу необработанным rejection
    return []
  }
}